/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import { capitalize } from '@/services/utils';
import axios from 'axios';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
export const useMeStore = defineStore('meStore', {
  state: () => {
    const {
      handleError
    } = useSnackbarHandler();
    return {
      handleError,
      me: {},
      terms: {},
      access: {},
      features: {},
      settings: {},
      company: {},
      permissions: {},
      nextClientReference: null
    };
  },
  actions: {
    async getMe(forcereset = false) {
      try {
        if (Object.keys(this.me).length && !forcereset) {
          return this.me;
        }
        const response = await axios({
          url: '/me'
        });
        Object.entries(response.data.terms).forEach(([term, str]) => {
          response.data.terms[capitalize(term)] = capitalize(str);
        });

        // Initialize label property like Angular UserService does
        response.data.label = response.data.first;
        this.$patch({
          me: response.data,
          terms: response.data.terms,
          features: response.data.features,
          settings: response.data.settings,
          company: response.data.company,
          permissions: response.data.permissions,
          access: response.data.access
        });
        return response.data;
      } catch (error) {
        this.handleError(error);
        return {};
      }
    },
    async updateMe(update) {
      try {
        const response = await axios({
          url: `/me`,
          method: 'PUT',
          data: update
        });
        this.$patch({
          me: response.data,
          terms: response.data.terms,
          features: response.data.features,
          settings: response.data.settings,
          company: response.data.company,
          permissions: response.data.permissions,
          access: response.data.access
        });
      } catch (error) {
        this.handleError(error);
      }
    },
    async getMyCompanyReferences(clientId = null) {
      try {
        const params = {};
        if (clientId) {
          params.clientId = clientId;
        }
        const response = await axios({
          url: `/me/company/references`,
          method: 'GET',
          params
        });
        return response.data;
      } catch (error) {
        this.handleError(error);
        return [];
      }
    },
    async getFixedFeeColumns() {
      try {
        const response = await axios({
          url: `/me/fixed-fees/columns`,
          method: 'GET'
        });
        return response.data;
      } catch (error) {
        this.handleError(error);
        return null;
      }
    },
    async updateFixedFeeColumns(visibleColumns) {
      try {
        const response = await axios({
          url: `/me/fixed-fees/columns`,
          method: 'PUT',
          data: {
            visibleColumns
          }
        });

        // Update local settings state using $patch for proper reactivity
        this.$patch({
          settings: {
            ...this.settings,
            fixedFeeTableColumns: {
              ...this.settings?.fixedFeeTableColumns,
              visibleColumns
            }
          }
        });
        return response.data;
      } catch (error) {
        this.handleError(error);
        throw error;
      }
    }
  }
});